export const ViewType = {
  Standalone: "standalone",
  Incadea: "incadea"
} as const;

export type ViewType = typeof ViewType[keyof typeof ViewType];